// Load Yotpo main widget
(function() {
  var s = document.createElement("script");
  s.async = true;
  s.src = "//staticw2.yotpo.com/OaGjliCPnYy4xZnaVIikErUxhqggenxZyAN8VDeo/widget.js";
  document.head.appendChild(s);
})();

// Load Yotpo language-specific loader dynamically
(function() {
  var lang = document.documentElement.getAttribute("lang") || "en";
  var s = document.createElement("script");
  s.async = true;
  s.src =
    "https://cdn-widgetsrepository.yotpo.com/v1/loader/" +
    "OaGjliCPnYy4xZnaVIikErUxhqggenxZyAN8VDeo" +
    "?languageCode=" + lang;
  document.head.appendChild(s);
})();
